//@ts-nocheck

// import normalizerForm from '@models/base/Form'
import normalizeImage from '../base/ImageBase'
// import normalizeModalForm from '@models/base/ModalForm'

interface FeatureItem {
  [key: string]: any;
}

interface FeatureListsProps {
  type: string;
  sectionId: string;
  colorScheme: string;
  sectionTitle: string;
  items?: FeatureItem[];
  ctaPrimary: any;
  ctaSecondary: any;
}

interface NormalizedFeatureLists extends Omit<FeatureListsProps, 'items'> {
  items: ReturnType<typeof normalizeImage>[];
}

const FeatureLists = ({
  type,
  sectionId,
  colorScheme,
  sectionTitle,
  items = [],
  ctaPrimary,
  ctaSecondary,
}: FeatureListsProps): NormalizedFeatureLists => {
  const normalizedItems = items.map((el) => {
    const normalizedImage = el.image ? normalizeImage(el.image) : null
    // const normalizedModal = normalizeModalForm(el?.modal)
    return {
      ...el,
      image: normalizedImage,
      // modal: normalizedModal,
    }
  })


  const normalizedData: NormalizedFeatureLists = {
    type,
    sectionId,
    colorScheme,
    sectionTitle,
    items: normalizedItems,
    ctaPrimary,
    ctaSecondary,
  }

  return normalizedData
}

export default FeatureLists
